var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNaira = function SvgNaira(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.011 42.204c10.377 0 18.79-8.413 18.79-18.79 0-10.377-8.413-18.789-18.79-18.789-10.377 0-18.79 8.412-18.79 18.79 0 10.377 8.413 18.789 18.79 18.789Zm10.14-20.358a.976.976 0 0 0-.976-.975h-.915v-5.795a1.504 1.504 0 1 0-3.007 0v5.795h-5.311l-4.521-6.506a1.846 1.846 0 0 0-3.362 1.053v5.453h-.915a.976.976 0 1 0 0 1.951h.915v2.264h-.915a.976.976 0 1 0 0 1.951h.915v5a1.518 1.518 0 0 0 3.037 0v-5h5.838l3.988 5.731a1.833 1.833 0 0 0 3.338-1.047v-4.684h.915a.976.976 0 1 0 0-1.951h-.915v-2.264h.915a.976.976 0 0 0 .976-.976Zm-4.898.976h-3.956l1.573 2.264h2.383v-2.264Zm0 4.215h-1.027l.805 1.157a.122.122 0 0 0 .222-.07v-1.087Zm-5.677-1.951-1.575-2.264h-2.905v2.264h4.48Zm-4.48-4.215h1.547l-1.337-1.922a.115.115 0 0 0-.21.066v1.856Z",
    fill: "currentcolor"
  })));
};
export default SvgNaira;